<template>
  <div>
    <div class="sill"></div>
    <div class="re-bigbox">
      <div class="flex-x-center">
        <div class="con-register">
          <el-menu
            active-text-color="#539fea"
            :default-active="activeIndex"
            class="el-menu-demo flex-between"
            mode="horizontal"
          >
            <el-menu-item
              @click="routeHop('/testregistration')"
              class="title-fontsize flex-y-center"
              index="1"
              ><span
                class="applyicon-fontsize iconfont icon-TAyewubanli"
              ></span>
              考试报名</el-menu-item
            >
            <div class="sill-t"></div>

            <el-menu-item
              @click="routeHop('/onlinemall')"
              class="title-fontsize flex-y-center"
              index="3"
            >
              <span
                style="margin-right: 4px"
                class="icon-fontsize iconfont icon-shangcheng1"
              ></span
              >在线商城</el-menu-item
            >
            <div class="sill-t"></div>
            <el-menu-item
              @click="routeHop('/home')"
              class="title-fontsize flex-y-center"
              index="4"
            >
              <span
                style="margin-right: 4px"
                class="icon-fontsize k iconfont icon-wode"
              ></span
              >我的资料</el-menu-item
            >
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return { activeIndex: "0", activeIndexTwo: "2", radio: "1" };
  },
  methods: {
    routeHop(url) {
      this.$router.push(url);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
.sill-t {
  width: 1px;
  height: 30px;
  background-color: rgb(239, 232, 232);
  margin-top: 10px;
}
.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(239, 232, 232);
  margin: 20px 0px;
}
.tip {
  margin-left: 30px;
  color: rgb(231, 154, 92);
}
.line {
  background-color: rgb(230, 224, 224);
  width: 100%;
  height: 1px;
  margin: 40px 0px;
}
.change-password {
  color: #539fea;
}
.alter {
  margin-left: 30px;
  color: #539fea;
}
.id {
  margin-left: 30px;
  margin-top: 15px;
  color: gray;
}
.my-pro {
  margin-left: 30px;
}
.three-class {
  margin-top: 40px;
}
.line-three {
  margin: 0px 70px;
}
.icons {
  color: snow;
  font-size: 26px;
}
.icon-circle {
  width: 40px;
  height: 40px;
  background-color: #539fea;
  border-radius: 100%;
  margin-top: 5px;
}
.applyicon-fontsize {
  font-size: 25px;
}
.icon-fontsize {
  font-size: 20px;
  margin-right: 3px;
}
.title-fontsize {
  font-size: 20px;
  height: 60px;
}
.person-profile {
  margin-top: 70px;
}
.two-menu {
  margin-top: 30px;
  font-weight: 500;
}
.notice {
  margin: 0px 30px;
  color: #539fea;
  font-weight: 600;
  font-size: 19px;
}
.off {
  color: #539fea;
  font-size: 18px;
}
.two-icon {
  margin: 20px 40px;
}
.load-nows {
  color: #539fea;
  border: none;
  font-size: 16px;
}
.load-now {
  margin-right: 30px;
  margin-top: 15px;
  color: #000;
}
.register {
  font-size: 20px;
  margin-top: 60px;
}
.con-register {
  width: 100%;

  background-color: rgb(250, 250, 250);
  /* margin-top: 30px; */
}
.title-img {
  width: 40px;
  height: 40px;
  margin: 10px 20px 10px 50px;
  border-radius: 30px;
}

.re-title {
  height: 10%;
  font-size: 18px;
  font-weight: 500;
  color: #539fea;
}
</style>
